import { createFileRoute, redirect } from '@tanstack/react-router'

import { useAuthStore } from '@/shared/auth/stores/authStore'
import { isHiddenEntity } from '@/shared/constants/demo-data'
import { ResponseDetailPage } from '@/systems/surveys/features/response-detail/components/ResponseDetailPage'
import {
  taskDetailQueryOptions,
  taskIssuesQueryOptions,
} from '@/systems/surveys/features/response-detail/hooks/useTasks'

export const Route = createFileRoute('/entities/$id_/response-details')({
  beforeLoad: ({ params }) => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    if (isHiddenEntity(params.id)) {
      throw redirect({ to: '/entities' })
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    taskId: (search['taskId'] as string) ?? '',
  }),
  loaderDeps: ({ search }) => ({ taskId: search.taskId }),
  loader: ({ context: { queryClient }, deps: { taskId } }) => {
    if (taskId) {
      void queryClient.prefetchQuery(taskDetailQueryOptions(taskId))
      void queryClient.prefetchQuery(taskIssuesQueryOptions(taskId))
    }
  },
  component: ResponseDetailRoute,
})

function ResponseDetailRoute() {
  const { taskId } = Route.useSearch()
  return (
    <ResponseDetailPage
      taskId={taskId}
      onBack={() => window.history.back()}
    />
  )
}
